import React from "react";
import TreasuryCoordinatorOrderListing from "../../TreasuryCoordinator/TreasuryCoordinatorOrderListing.js";
function ClearnaceCoordinatorTransactionListing() {
  return (
    <TreasuryCoordinatorOrderListing
     isEdit={false}
    />
  );
}

export default ClearnaceCoordinatorTransactionListing;
